/* eslint-disable no-console */
export const log = (tags: string[], state, type, message, rawError) => {
    console.log(tags, state, type, message, rawError);
};
